export { default } from './PriceLabel';
